var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUpColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 9.16699L9.16669 1.66699C9.82973 1.66699 10.4656 1.93038 10.9345 2.39923C11.4033 2.86807 11.6667 3.50395 11.6667 4.16699V7.50033H16.3834C16.6249 7.49759 16.8642 7.54741 17.0847 7.64634C17.3051 7.74527 17.5014 7.89094 17.6599 8.07325C17.8184 8.25557 17.9354 8.47018 18.0028 8.7022C18.0702 8.93423 18.0863 9.17812 18.05 9.41699L16.9 16.917C16.8398 17.3144 16.6379 17.6767 16.3316 17.937C16.0253 18.1973 15.6353 18.3382 15.2334 18.3337H5.83335M5.83335 9.16699V18.3337M5.83335 9.16699H3.33335C2.89133 9.16699 2.4674 9.34259 2.15484 9.65515C1.84228 9.96771 1.66669 10.3916 1.66669 10.8337V16.667C1.66669 17.109 1.84228 17.5329 2.15484 17.8455C2.4674 18.1581 2.89133 18.3337 3.33335 18.3337H5.83335",
    stroke: "#83C372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_2158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpColor);
export default __webpack_public_path__ + "static/media/thumbsUpColor.faec36ba14a5fdcf3766ab0be9916595.svg";
export { ForwardRef as ReactComponent };